import React from "react";
import {
  Button,
  Checkbox,
  Form,
  Icon,
  Input,
  InputNumber,
  message,
  Modal,
  Select,
} from "antd";
import {
  addPhotographySolutionRequest,
  getPhotographyCompanyRequest,
} from "../../actions/photographerActions";
import qs from "query-string";
import "./style.scss";
import { PHONE_CODES, COUNTRY_NAME } from "../../define";

const FormItem = Form.Item;
const preferredMethodOptions = [
  { label: "Text", value: "text" },
  { label: "Call", value: "call" },
  { label: "Email", value: "email" },
];
const preferredMethodDayOfWeekOptions = [
  { label: "Monday Morning", value: "monday_morning" },
  { label: "Monday Afternoon", value: "monday_afternoon" },
  { label: "Tuesday Morning", value: "tuesday_morning" },
  { label: "Tuesday Afternoon", value: "tuesday_afternoon" },
  { label: "Wednesday Morning", value: "wednesday_morning" },
  { label: "Wednesday Afternoon", value: "wednesday_afternoon" },
  { label: "Thursday Morning", value: "thursday_morning" },
  { label: "Thursday Afternoon", value: "thursday_afternoon" },
  { label: "Friday Morning", value: "friday_morning" },
  { label: "Friday Afternoon", value: "friday_afternoon" },
  { label: "Saturday Morning", value: "saturday_morning" },
  { label: "Saturday Afternoon", value: "saturday_afternoon" },
  { label: "Sunday Morning", value: "sunday_morning" },
  { label: "Sunday Afternoon", value: "sunday_afternoon" },
];

class AddPhotographySolutionForm extends React.Component {
  goTo(route) {
    this.props.history.replace(`${route}`);
  }

  state = {
    errors: [],
    preferredMethodDayOfWeek: [],
    preferredMethod: [],
    loading: false,
    company: "",
  };

  componentDidMount() {
    const slug = qs.parse(this.props.location.search).company || "";
    getPhotographyCompanyRequest(slug).then((res) => {
      if (res.data.data) {
        this.setState({ company: res.data.data });
      }
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if (
      !this.state.company ||
      (this.state.company && !this.state.company.googleSheetId)
    ) {
      return message.error("Company Slug Incorrect.");
    }
    if (!this.state.preferredMethodDayOfWeek.length) {
      return message.error("Please choose Preferred Method Day Of Week.");
    }
    if (!this.state.preferredMethod.length) {
      return message.error("Please choose Preferred Method.");
    }
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log("values", values);
      if (!err) {
        this.setState({ loading: true });
        let prefixPhone = values.phonePrefix.replace("+", "");
        let additionalQuestionsAndConcerns =
          values.additionalQuestionsAndConcerns;
        delete values.additionalQuestionsAndConcerns;
        delete values.phonePrefix;
        addPhotographySolutionRequest({
          ...values,
          contactPhoneNumber: !values.contactPhoneNumber
            ? null
            : values.contactPhoneNumber.toString().length > 10
            ? `${prefixPhone} ${values.contactPhoneNumber
                .toString()
                .slice(0, -1)}`
            : `${prefixPhone} ${values.contactPhoneNumber.toString()}`,
          googleSheetId: this.state.company.googleSheetId,
          preferredMethod: this.state.preferredMethod,
          preferredMethodDayOfWeek: this.state.preferredMethodDayOfWeek,
          additionalQuestionsAndConcerns: additionalQuestionsAndConcerns,
        })
          .then((res) => {
            Modal.confirm({
              title:
                "Got it. A team member will email you with a confirmation once we've successfully assigned a photographer for your shoot.",
              icon: <Icon type="check-circle" />,
              okText: "Submit Another Form",
              cancelText: "Back to Home",
              className: "modal-confirm-success",
              onOk: () => {
                this.setState({
                  preferredMethodDayOfWeek: [],
                  preferredMethod: [],
                });
                this.props.form.resetFields();
              },
              onCancel: () => {
                console.log("cancel");
              },
            });
          })
          .catch((err) => {
            console.log(err.response);
            let errMsg = "Something went wrong! Please try again.";
            if (err.response && err.response.data) {
              errMsg = err.response.data.message;
            }
            message.error(errMsg);
          })
          .finally(() => this.setState({ loading: false }));
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <div className="form-solutions-page">
        <div className="wp-inner">
          <div className="banner row">
            <div className="thumb">
              <img src="/images/rio.jpg" alt="" />
            </div>
          </div>

          <div className="row">
            <h1>Choose Your Preferred Shoot Days (UScellular®)</h1>
            <p>
              Any contact information obtained will only be used to arrange your
              photosession.{" "}
            </p>
            <p>
              For location managers requesting photoshoots at multiple
              locations, please submit a separate form for each of your
              locations. Thank you!
            </p>
          </div>
          <div className="row">
            <h3>
              Photography Campaign for{" "}
              {this.state.company ? this.state.company.companyName : ""}
            </h3>
            <div className="thumb">
              <img
                width={300}
                src={
                  this.state.company && this.state.company.companyLogo
                    ? this.state.company.companyLogo.original
                    : ""
                }
                alt="Not Found"
              />
            </div>
          </div>

          <Form
            onSubmit={this.handleSubmit}
            layout="vertical"
            className="form-solutions"
          >
            {this.state.errors.map((error) => (
              <div>{error.message}</div>
            ))}

            <FormItem
              label={
                <div className="label-input">
                  <p>
                    Please input the <span>street address</span> of your store
                    location
                  </p>
                  <p>
                    Example: <span>123 Main Ave Suite 321</span>
                  </p>
                </div>
              }
              hasFeedback
            >
              {getFieldDecorator("streetAddress", {
                rules: [
                  {
                    required: true,
                    message: "Please input your street address",
                  },
                ],
              })(<Input placeholder="Your answer" />)}
            </FormItem>

            <FormItem
              label={
                <div className="label-input">
                  <p>
                    Please input the <span>City/Town</span> of your store
                    location
                  </p>
                  <p>
                    Example: <span>Beverly Hills</span>
                  </p>
                </div>
              }
              hasFeedback
            >
              {getFieldDecorator("city", {
                rules: [{ required: true, message: "Please input your city" }],
              })(<Input placeholder="Your answer" />)}
            </FormItem>
            <FormItem
              label={
                <div className="label-input">
                  <p>
                    Please input the <span>state</span> of your store location
                  </p>
                  <p>
                    Example: <span>CA</span>
                  </p>
                </div>
              }
              hasFeedback
            >
              {getFieldDecorator("state", {
                rules: [{ required: true, message: "Please input your state" }],
              })(<Input placeholder="Your answer" />)}
            </FormItem>

            <FormItem
              label={
                <div className="label-input">
                  <p>
                    Please input the <span>zip code</span> of your store
                    location
                  </p>
                  <p>
                    Example: <span>90210</span>
                  </p>
                </div>
              }
              hasFeedback
            >
              {getFieldDecorator("zip", {
                rules: [
                  { required: true, message: "Please input your zip code" },
                ],
              })(<Input placeholder="Your answer" />)}
            </FormItem>
            <FormItem
              label={
                <div className="label-input">
                  <p>Contact Name at Location:</p>
                </div>
              }
              hasFeedback
            >
              {getFieldDecorator("contactName", {
                rules: [
                  { required: true, message: "Please input contact name" },
                ],
              })(<Input placeholder="Your answer" />)}
            </FormItem>

            <FormItem
              label={
                <div className="label-input">
                  <p>Contact Email Address: (work email address please)</p>
                  <p>
                    Your work email address will only be used for arranging your
                    photosession.{" "}
                  </p>
                </div>
              }
              hasFeedback
            >
              {getFieldDecorator("contactEmail", {
                rules: [
                  {
                    type: "email",
                    message: "The input is not valid E-mail",
                  },
                  {
                    required: true,
                    message: "Please input your E-mail",
                  },
                ],
              })(<Input placeholder="Your answer" />)}
            </FormItem>

            <div className="row-input-phone">
              <div className="label-input-phone">
                <span className="required">*</span>
                <div>
                  <p>Contact Phone Number:</p>
                  <p>
                    Your phone number will only be used for arranging your
                    photosession.
                  </p>
                </div>
              </div>
              <div className="input-form-phone">
                <FormItem>
                  {getFieldDecorator("phonePrefix", {
                    initialValue: "+1",
                  })(
                    <Select style={{ width: 200 }}>
                      {Object.keys(PHONE_CODES)
                        .filter((el) => el)
                        .map((key, index) => (
                          <Select.Option key={key} value={PHONE_CODES[key]}>{`${
                            COUNTRY_NAME[key] ? COUNTRY_NAME[key] : key
                          } ${PHONE_CODES[key]}`}</Select.Option>
                        ))}
                    </Select>
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator("contactPhoneNumber", {
                    rules: [
                      { required: true, message: "Please input your phone" },
                      {
                        min: 10,
                        message: "Phone number must be 10 characters long",
                        transform: (value) => {
                          return value ? value.toString() : "";
                        },
                      },
                    ],
                  })(
                    <InputNumber
                      placeholder="Your answer"
                      formatter={(value) => {
                        if (!value) return value;

                        let previousValue = value;
                        if (previousValue) {
                          previousValue = previousValue.slice(0, -1);
                        }
                        // only allows 0-9 inputs
                        const currentValue = value.replace(/[^\d]/g, "");
                        const cvLength = currentValue.length;

                        if (
                          !previousValue ||
                          value.length > previousValue.length
                        ) {
                          // returns: "x", "xx", "xxx"
                          if (cvLength < 4) return currentValue;

                          // returns: "(xxx)", "(xxx) x", "(xxx) xx", "(xxx) xxx",
                          if (cvLength < 7)
                            return `${currentValue.slice(
                              0,
                              3
                            )}-${currentValue.slice(3)}`;

                          // returns: "(xxx) xxx-", (xxx) xxx-x", "(xxx) xxx-xx", "(xxx) xxx-xxx", "(xxx) xxx-xxxx"
                          return `${currentValue.slice(
                            0,
                            3
                          )}-${currentValue.slice(3, 6)}-${currentValue.slice(
                            6,
                            10
                          )}`;
                        } else {
                          return;
                        }
                      }}
                      parser={(value) => value.replace(/\-\s?|(,*)/g, "")}
                    />
                  )}
                </FormItem>
              </div>
            </div>

            <FormItem
              label={
                <div className="label-input add-required">
                  <p>
                    {" "}
                    <span className="required">*</span> Preferred Method of
                    Contact
                  </p>
                </div>
              }
              hasFeedback
            >
              <Checkbox.Group
                options={preferredMethodOptions}
                value={this.state.preferredMethod}
                onChange={(values) =>
                  this.setState({ preferredMethod: values })
                }
              />
            </FormItem>
            <FormItem
              label={
                <div className="label-input add-required">
                  <p>
                    {" "}
                    <span className="required">*</span>Preferred Day(s) of the
                    Week
                  </p>
                </div>
              }
              hasFeedback
            >
              <Checkbox.Group
                options={preferredMethodDayOfWeekOptions}
                value={this.state.preferredMethodDayOfWeek}
                onChange={(values) =>
                  this.setState({ preferredMethodDayOfWeek: values })
                }
              />
            </FormItem>
            <FormItem
              label={
                <div className="label-input">
                  <p>Additional Questions and Concerns</p>
                </div>
              }
              hasFeedback
            >
              {getFieldDecorator(
                "additionalQuestionsAndConcerns",
                {}
              )(<Input placeholder="Your answer" />)}
            </FormItem>

            <FormItem>
              <Button
                loading={this.state.loading}
                type="primary"
                htmlType="submit"
              >
                Submit
              </Button>
            </FormItem>
          </Form>
        </div>
      </div>
    );
  }
}

const WrappedAddPhotographySolutionForm = Form.create()(
  AddPhotographySolutionForm
);

export default WrappedAddPhotographySolutionForm;



// WEBPACK FOOTER //
// ./src/components/PhotographySolution/index.js